/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditLogItem } from './audit-log-item';
import {
    AuditLogItemFromJSON,
    AuditLogItemFromJSONTyped,
    AuditLogItemToJSON,
    AuditLogItemToJSONTyped,
} from './audit-log-item';

/**
 * Response containing paginated audit log entries
 * @export
 * @interface AuditLogResponse
 */
export interface AuditLogResponse {
    /**
     * List of audit log entries
     * @type {Array<AuditLogItem>}
     * @memberof AuditLogResponse
     */
    items: Array<AuditLogItem>;
    /**
     * Maximum number of items requested
     * @type {number}
     * @memberof AuditLogResponse
     */
    limit: number;
    /**
     * Number of items skipped
     * @type {number}
     * @memberof AuditLogResponse
     */
    offset: number;
}

/**
 * Check if a given object implements the AuditLogResponse interface.
 */
export function instanceOfAuditLogResponse(value: object): value is AuditLogResponse {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('offset' in value) || value['offset'] === undefined) return false;
    return true;
}

export function AuditLogResponseFromJSON(json: any): AuditLogResponse {
    return AuditLogResponseFromJSONTyped(json, false);
}

export function AuditLogResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(AuditLogItemFromJSON)),
        'limit': json['limit'],
        'offset': json['offset'],
    };
}

export function AuditLogResponseToJSON(json: any): AuditLogResponse {
    return AuditLogResponseToJSONTyped(json, false);
}

export function AuditLogResponseToJSONTyped(value?: AuditLogResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(AuditLogItemToJSON)),
        'limit': value['limit'],
        'offset': value['offset'],
    };
}

